import { PencilIcon } from 'lucide-react'
import type { FC, ReactNode } from 'react'

import { Button } from '@/components/ui/button'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { cn } from '@/lib/utils'

export interface InlineEditableTextDisplayProps {
  value: string
  className?: string
  onEditStart?: () => void
}

/**
 * Display state of the inline editable text component.
 */
export const InlineEditableTextDisplay: FC<InlineEditableTextDisplayProps> = ({
  value,
  className,
  onEditStart,
}): ReactNode => (
  <div className={cn('inline-editable-text-display flex min-w-0 items-center gap-1', className)}>
    <span className="truncate text-sm font-semibold" title={value}>
      {value}
    </span>
    {onEditStart && (
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            size="icon"
            className="inline-editable-text-edit-button size-7 shrink-0"
            onClick={onEditStart}
            aria-label="Edit name"
          >
            <PencilIcon className="size-3.5" />
          </Button>
        </TooltipTrigger>
        <TooltipContent side="bottom">Edit</TooltipContent>
      </Tooltip>
    )}
  </div>
)

InlineEditableTextDisplay.displayName = 'InlineEditableTextDisplay'
